import { useSyncExternalStore } from "react"

const MOBILE_BREAKPOINT = 768

function getMediaQueryList() {
  if (typeof window === "undefined") return null

  return window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`)
}

function mediaQueryListener(callback: (event: MediaQueryListEvent) => void) {
  const mql = getMediaQueryList()
  if (!mql) return () => undefined

  mql.addEventListener("change", callback)

  return () => {
    mql.removeEventListener("change", callback)
  }
}

function isSmallerThanBreakpoint() {
  return getMediaQueryList()?.matches ?? false
}

export function useIsMobile() {
  return useSyncExternalStore(
    mediaQueryListener,
    isSmallerThanBreakpoint,
    () => false,
  )
}
